// extracted by mini-css-extract-plugin
export default {"letterHeader":"letterHeader--3Lh3Y","terms":"terms--3AUJ2"};